import React from "react"

const ContentWithIndex = ({ toc, content, sectionTitle, tocTitle, handleMobileTocShow, sectionId='skill-list' }) => {

  return (
    <section className="content-w-toc" id={sectionId}>
      <div className="container">
        <h2>{sectionTitle}</h2>
        <div className="mobile-btn"
          onClick={handleMobileTocShow}
        ><label className="boxed-btn white">{tocTitle}</label></div>
      </div>
      <div className="container row">
        <div className="l-col">
          <h3
            onClick={handleMobileTocShow}
            className="col y-center"
          >{tocTitle}</h3>
          <ul className="home-filters">
            {toc}
          </ul>
        </div>
        <div className="r-col">    
          {content}
        </div>
      </div>
    </section>
  )
}

export default ContentWithIndex